<template>
  <v2-modal
    :show="show"
    title="Download Wishlist"
    size="lg"
    @close="$emit('close')"
  >
    <div class="v2-download-modal">
      <p class="v2-text-sm v2-font-bold v2-text-primary v2-mb-3">
        Select a file format
      </p>
      <div class="v2-download-modal__grid">
        <div
          v-for="fileFormat of DOWNLOAD_OPTIONS.WISHLIST"
          :key="fileFormat.value"
          class="v2-download-modal__option"
          :class="{ 'v2-download-modal__option--active': selectedType && selectedType.value === fileFormat.value }"
          @click="selectedType = fileFormat"
        >
          <component
            :is="getIconComponent(fileFormat.fileType)"
            class="v2-download-modal__icon"
          />
          <small class="v2-mt-1 v2-text-xs text-center">{{ fileFormat.text }}</small>
        </div>
      </div>
    </div>
    <template #footer>
      <v2-button
        variant="outline"
        @click="$emit('close')"
      >
        Cancel
      </v2-button>
      <v2-button
        :disabled="!selectedType || isDownloading"
        :loading="isDownloading"
        @click="onClickDownload"
      >
        {{ isDownloading ? 'Downloading...' : 'Download' }}
      </v2-button>
    </template>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import PdfIcon from '@/@core/assets/svg-components/PdfIcon.vue'
import XlsxIcon from '@/@core/assets/svg-components/XlsxIcon.vue'
import ZipIcon from '@/@core/assets/svg-components/ZipIcon.vue'
import PptxIcon from '@/@core/assets/svg-components/PptxIcon.vue'
import constants, { FILE_FORMATS } from '@/constants'

const { DOWNLOAD_OPTIONS } = constants

export default {
  name: 'V2DownloadWishlistModal',
  components: { V2Modal, V2Button },
  props: {
    show: { type: Boolean, default: false },
    isDownloading: { type: Boolean, default: false },
  },
  data() {
    return {
      DOWNLOAD_OPTIONS,
      selectedType: null,
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.selectedType = null
      }
    },
  },
  methods: {
    onClickDownload() {
      this.$emit('download', this.selectedType)
    },
    getIconComponent(format) {
      switch (format?.toLowerCase()) {
        case FILE_FORMATS.PDF: return PdfIcon
        case FILE_FORMATS.XLSX: return XlsxIcon
        case FILE_FORMATS.ZIP: return ZipIcon
        case FILE_FORMATS.PPTX: return PptxIcon
        default: return XlsxIcon
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-download-modal {
  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--v2-space-2);
  }

  &__option {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--v2-space-4);
    // Glass card — matches V2Card variant="card". Nested inside the
    // download modal (which is already a glass panel), so we use the
    // lighter blur + thinner stroke for the secondary surface.
    background: var(--v2-glass-surface-2);
    backdrop-filter: blur(var(--v2-glass-blur-sm)) saturate(160%);
    border: 1px solid var(--v2-glass-stroke);
    border-radius: var(--v2-radius-md);
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;

    &:hover,
    &--active {
      border-color: var(--v2-glass-stroke-strong);
    }
  }

  &__icon {
    width: 28px;
    height: 28px;
    color: var(--v2-foreground);
  }
}

.v2-text-primary {
  color: var(--v2-primary);
}
</style>
